import { AppConfig, getConfig } from '@tcs/create-account/utils/configService';
import { createContext, ReactNode, useEffect, useState } from 'react';

export const ConfigContext = createContext<AppConfig & { loading: boolean }>(
  null!
);

const ConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    (async () => {
      const config = await getConfig();
      setConfig(config);
      setLoading(false);
    })();
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        loading,
        ...config,
      }}>
      {children}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
